import Functions from "../functions";

export default {
    init() {
        // JavaScript to be fired on the home page
        var firstloader = new Loader();
               firstloader.reset();
               firstloader.setCompleteCallback([function () {
                   setTimeout(function () {
                       $('html').removeClass('show-landing');
                       $('html').addClass('show-anim');

                       setTimeout(function () {
                           Functions.scrollbarEvent();
                           // Functions.scrollbar.addListener(Functions.scrollbarEvent);
                       }, 500);
                   }, 500);
               }]);
               firstloader.start();
    },
    finalize() {
        // JavaScript to be fired on the home page, after the init JS
    },
};


function Loader() {
    this.id = Math.random() * 1000
    this.reset()
}

Loader.prototype.setContainer = function (domElmnt) {
    this.targetContainer = domElmnt
}

Loader.prototype.start = function () {
    var self = this
    this.showBar()
    this.theInterval = setInterval(function () {
        self.intervalChecker()
    }, 1)
    this.setLoadList()
    this.loadingCheck()
}

Loader.prototype.reset = function () {
    this.theInterval = null
    this.targetContainer = false
    this.cbComplete = null
    this.imgLoaded = 0
    this.imgToLoad = 0
    this.loadList = null
    this.setLoadingBar()
}

Loader.prototype.setCompleteCallback = function (callbackComplete) {
    this.cbComplete = callbackComplete
}

Loader.prototype.setLoadList = function () {
    var self = this;
    var searchlist;
    if (this.targetContainer) {
        searchlist = this.setContainer + 'div, ' + this.setContainer + ' img'
    } else {
        searchlist = 'div, img'
    }

    this.loadList = null
    this.loadList = $(searchlist).filter(function () {

        if ($(this).css("background-image").indexOf("url") > -1) {
            return true;
        }
        var attr = $(this).attr('src');
        if (typeof attr !== typeof undefined && attr !== false) {
            return true;
        }
    });

    this.imgToLoad = 0;
    this.loadList.each(function () {
        self.imgToLoad++
    })
}

Loader.prototype.loadingCheck = function () {
    var self = this
    var tabUlr = new Array()

    this.loadList.each(function () {

        if (this.tagName.toLowerCase() != 'img') {

            var regular = new RegExp(/url\(([^()]*)\)/);
            var bi = $(this).css("background-image").match(regular).pop();
            var regReplace = new RegExp('[\'"]', 'gi');
            bi = bi.replace(regReplace, ''); // bug IE, Safari, EDGE, Chrome
            if (tabUlr.indexOf(bi) < 0) {
                tabUlr.push(bi)
            }

        } else {

            var imgsrc = $(this).attr('src');
            if (tabUlr.indexOf(imgsrc) < 0) {
                tabUlr.push(imgsrc)
            }

        }
    });

    this.imgToLoad = tabUlr.length

    for (var n = 0; n < tabUlr.length; n++) {
        $('<img/>').on('load', function () {
            $(this).remove();
            self.imgLoaded++
        }).on('error', function () {
            $(this).remove();
            self.imgLoaded++
        }).attr('src', tabUlr[n])
    }
}

Loader.prototype.intervalChecker = function () {
    this.setLoadingBar()
    this.checkForCallback()
}

Loader.prototype.checkForCallback = function () {
    if (this.imgLoaded >= this.imgToLoad) {
        clearTimeout(this.theInterval)
        this.hideBar()
        this.theInterval = null
        for (var i = 0; i < this.cbComplete.length; i++) {
            this.cbComplete[i]()
        }

        $(window).trigger('loadComplete');
    }
}

Loader.prototype.setLoadingBar = function () {
    var percent;
    if (this.imgToLoad > 0) {
        percent = this.imgLoaded / this.imgToLoad * 100;
    } else {
        percent = 0
    }
    // var self = this
    setTimeout(function () {
        $('#loaderbar').css('width', Math.ceil(percent) + '%');
    })
}

Loader.prototype.hideBar = function () {
    $('#loaderbar').fadeOut();
}

Loader.prototype.showBar = function () {
    $('#loaderbar').fadeIn(100);
}

Loader.prototype.autoDestroy = function () {
    for (var key in this) {
        this[key] = null;
    }
}

Loader.prototype.sleep = function (milliseconds) {
    var start = new Date().getTime();
    for (var i = 0; i < 1e7; i++) {
        if ((new Date().getTime() - start) > milliseconds) {
            break;
        }
    }
}


// WEBPACK FOOTER //
// ./scripts/routes/home.js